// Parses HTMl from CMS into components replacing links accordingly

import parse from 'html-react-parser'
import domToReact from 'html-react-parser/lib/dom-to-react'
import { Table } from 'reactstrap'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { pathToHrefAs } from '~/lib/helpers/pathToHrefAs'
import { EMBED_VALUE_TOKEN, EMBEDDED_MEDIA_TOKENS } from '~/lib/constants/embedded'

// Parser options
const parserOptions = {
  replace: node => {
    // Replace local links with router links
    if (node.name === 'a' && node.attribs.href && node.attribs.href.match(/^\//)) {
      const { href, as } = pathToHrefAs(node.attribs.href)

      return (
        <Link href={href} as={as}>
          <a {...node.attribs}>
            {domToReact(node.children, parserOptions)}
          </a>
        </Link>
      )
    } else if (node.name === 'table') {
      return (
        <Table responsive size='sm'>
          {domToReact(node.children, parserOptions)}
        </Table>
      )
    }
  }
}

// Create embedded elements from links in the following formats:
//  Generic embeds - <p>embed:{URL}</p>
//  YouTube videos - <p>youtube:{VIDEO_ID}</p>
//  Vimeo videos - <p>vimeo:{VIDEO_ID}</p>
function parseEmbedLinks (html) {
  const tokens = Object.keys(EMBEDDED_MEDIA_TOKENS)
  const tokenRegExp = new RegExp(`<p>(${tokens.join('|')}):([^<]*)</p>`, 'g')

  return html.replace(tokenRegExp, (match, token, value) => {
    const sourceUrl = EMBEDDED_MEDIA_TOKENS[token].replace(EMBED_VALUE_TOKEN, value)

    if (token === 'video') {
      return `
      <div class="embed-responsive embed-responsive-16by9 mb-3">
        <video class="embed-responsive-item" controls src='${sourceUrl}'></video>
      </div>
    `
    } else {
      return `
      <div class="embed-responsive embed-responsive-16by9 mb-3">
        <iframe class="embed-responsive-item" controls src='${sourceUrl}'></iframe>
      </div>
    `
    }
  })
}

function CmsHtml ({ html }) {
  const embeddedHtml = parseEmbedLinks(html)

  return parse(embeddedHtml, parserOptions)
}

CmsHtml.propTypes = {
  html: PropTypes.string
}

export default CmsHtml
